const KNOWN_TRANSLATIONS: Record<string, string> = {
  "invalid email or password": "El email o la contraseña son incorrectos.",
  "invalid password": "La contraseña es incorrecta.",
  "invalid email": "El email no es válido.",
  "email not verified": "Primero verificá tu email para continuar.",
  "email verification required": "Primero verificá tu email para continuar.",
  "user already exists": "Ya existe una cuenta con ese email.",
  "user not found": "No encontramos una cuenta con esos datos.",
  "invalid token": "El enlace no es válido.",
  "token expired": "El enlace venció. Solicitá uno nuevo.",
  "too many requests":
    "Hiciste demasiados intentos. Esperá un momento y volvé a probar.",
  "failed to fetch":
    "No pudimos conectarnos con Ronda. Revisá tu conexión e intentá nuevamente.",
  "network request failed":
    "No pudimos conectarnos con Ronda. Revisá tu conexión e intentá nuevamente.",
  "networkerror when attempting to fetch resource":
    "No pudimos conectarnos con Ronda. Revisá tu conexión e intentá nuevamente.",
  "load failed":
    "No pudimos conectarnos con Ronda. Revisá tu conexión e intentá nuevamente.",
  unauthorized: "Tu sesión venció. Volvé a ingresar.",
  forbidden: "No tenés permiso para realizar esta acción.",
  "not found": "No encontramos lo que buscabas.",
  "internal server error": "Ocurrió un problema en Ronda. Intentá nuevamente.",
  "bad request": "Revisá los datos enviados.",
  conflict: "El cambio entra en conflicto con el estado actual.",
  "service unavailable":
    "Ronda no está disponible en este momento. Intentá nuevamente.",
};

const SPANISH_MESSAGE =
  /[áéíóúñ¿¡]|\b(?:el|la|los|las|un|una|no|tu|tus|para|por|con|sin|ya|falta|pudimos|revisá|ingresá|intentá|seleccioná|ese|esa|este|esta)\b/i;

function normalized(message: string) {
  return message
    .trim()
    .replace(/[.!]+$/, "")
    .toLocaleLowerCase("en");
}

/**
 * Convierte errores de proveedores y del navegador en texto apto para la UI.
 * Los mensajes propios, que ya están redactados en español, se conservan.
 * Si un proveedor agrega un texto en inglés que todavía no conocemos, nunca
 * se lo mostramos crudo a la persona: usamos un fallback claro en español.
 */
export function translateErrorMessage(
  message: string | null | undefined,
  fallback = "Ocurrió un error. Intentá nuevamente.",
): string {
  if (!message?.trim()) return fallback;

  const translation = KNOWN_TRANSLATIONS[normalized(message)];
  if (translation) return translation;

  return SPANISH_MESSAGE.test(message) ? message : fallback;
}

export function errorMessage(
  error: unknown,
  fallback = "Ocurrió un error. Intentá nuevamente.",
): string {
  return translateErrorMessage(
    error instanceof Error ? error.message : null,
    fallback,
  );
}
